import { portalApi } from '../../../api';
import { replaceArrayItemAt } from '../../../utils/arrayUtil';
import { createErrorToast, createSuccessToast, createToast } from '../app';
import { hideModal } from '../modal';

export const GET_COMPANY_CODES = 'GET_COMPANY_CODES';
export const GET_COMPANY_CODES_SUCCESS = 'GET_COMPANY_CODES_SUCCESS';
export const GET_COMPANY_CODES_FAILURE = 'GET_COMPANY_CODES_FAILURE';

export const GET_COMPANY_PROJECTS = 'GET_COMPANY_PROJECTS';
export const GET_COMPANY_PROJECTS_SUCCESS = 'GET_COMPANY_PROJECTS_SUCCESS';
export const GET_COMPANY_PROJECTS_FAILURE = 'GET_COMPANY_PROJECTS_FAILURE';

export const GET_COMPANY_POLICY_TYPES = 'GET_COMPANY_POLICY_TYPES';
export const GET_COMPANY_POLICY_TYPES_SUCCESS = 'GET_COMPANY_POLICY_TYPES_SUCCESS';
export const GET_COMPANY_POLICY_TYPES_FAILURE = 'GET_COMPANY_POLICY_TYPES_FAILURE';

export const GET_COMPANY = 'GET_COMPANY';
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';
export const GET_COMPANY_FAILURE = 'GET_COMPANY_FAILURE';

const GET_COMPANY_DEPARTMENTS = 'GET_COMPANY_DEPARTMENTS';
const GET_COMPANY_DEPARTMENTS_SUCCESS = 'GET_COMPANY_DEPARTMENTS_SUCCESS';
const GET_COMPANY_DEPARTMENTS_FAILURE = 'GET_COMPANY_DEPARTMENTS_FAILURE';

export const getCompany = companyId => async dispatch => {
  dispatch({ type: GET_COMPANY, companyId });

  try {
    const company = await portalApi.getCompany(companyId);
    dispatch({ type: GET_COMPANY_SUCCESS, company });
  } catch (error) {
    dispatch({ type: GET_COMPANY_FAILURE, error });
    throw error;
  }
};

export const GET_COMPANY_FEATURES = 'GET_COMPANY_FEATURES';
export const GET_COMPANY_FEATURES_SUCCESS = 'GET_COMPANY_FEATURES_SUCCESS';
export const GET_COMPANY_FEATURES_FAILURE = 'GET_COMPANY_FEATURES_FAILURE';

export const getCompanyFeatures = companyId => async dispatch => {
  dispatch({ type: GET_COMPANY_FEATURES, companyId });

  try {
    const features = await portalApi.getCompanyFeatures(companyId);

    dispatch({ type: GET_COMPANY_FEATURES_SUCCESS, features, companyId });
  } catch (error) {
    dispatch({ type: GET_COMPANY_FEATURES_FAILURE, error });
  }
};

export const GET_COMPANY_INTEGRATIONS = 'GET_COMPANY_INTEGRATIONS';
export const GET_COMPANY_INTEGRATIONS_SUCCESS = 'GET_COMPANY_INTEGRATIONS_SUCCESS';
export const GET_COMPANY_INTEGRATIONS_FAILURE = 'GET_COMPANY_INTEGRATIONS_FAILURE';

export const getCompanyIntegrations = companyId => async dispatch => {
  dispatch({ type: GET_COMPANY_INTEGRATIONS, companyId });

  try {
    const integrations = await portalApi.getCompanyIntegrations(companyId);

    dispatch({ type: GET_COMPANY_INTEGRATIONS_SUCCESS, integrations, companyId });
  } catch (error) {
    dispatch({ type: GET_COMPANY_INTEGRATIONS_FAILURE, error });
  }
};

export const getCompanyDepartments = (companyId, pageData = { pageSize: 100, pageNumber: 1 }) => async (dispatch, getState) => {
  dispatch({ type: GET_COMPANY_DEPARTMENTS });

  try {
    const { data, ...pageInfo } = await portalApi.getCompanyDepartments(
      companyId ?? selectCompanyId(getState()),
      pageData,
      { sort: 'name' }
    );

    dispatch({
      type: GET_COMPANY_DEPARTMENTS_SUCCESS,
      departments: data,
      adminDepartmentId: data.find(d => d.isAdmin),
      pageInfo
    });
  } catch (error) {
    dispatch({ type: GET_COMPANY_DEPARTMENTS_FAILURE, error });
  }
};

export const GET_COMPANY_STATS = 'GET_COMPANY_STATS';
export const GET_COMPANY_STATS_SUCCESS = 'GET_COMPANY_STATS_SUCCESS';
export const GET_COMPANY_STATS_FAILURE = 'GET_COMPANY_STATS_FAILURE';

export const getCompanyStats = companyId => async (dispatch, getState) => {
  dispatch({ type: GET_COMPANY_STATS });

  try {
    const stats = await portalApi.getCompanyStats(companyId ?? selectCompanyId(getState()));
    dispatch({ type: GET_COMPANY_STATS_SUCCESS, stats });
  } catch (error) {
    dispatch({ type: GET_COMPANY_STATS_FAILURE, error });
  }
};

export const getCompanyCodes = companyId => async (dispatch, getState) => {
  dispatch({ type: GET_COMPANY_CODES });

  try {
    const codes = await portalApi.getCompanyCodes(companyId ?? selectCompanyId(getState()));
    dispatch({ type: GET_COMPANY_CODES_SUCCESS, codes });
  } catch (error) {
    dispatch({ type: GET_COMPANY_CODES_FAILURE, error });
  }
};

export const getCompanyProjects = companyId => async (dispatch, getState) => {
  dispatch({ type: GET_COMPANY_PROJECTS });

  try {
    const { data } = await portalApi.getCompanyJobs(
      companyId ?? selectCompanyId(getState()),
      { pageSize: 100 }
    );
    dispatch({ type: GET_COMPANY_PROJECTS_SUCCESS, data });
  } catch (error) {
    dispatch({ type: GET_COMPANY_PROJECTS_FAILURE, error });
  }
};

export const getCompanyPolicyTypes = (companyId, filter) => async dispatch => {
  dispatch({ type: GET_COMPANY_POLICY_TYPES, companyId });

  try {
    const data = await portalApi.getCompanyPolicyTypes(companyId, filter);
    dispatch({ type: GET_COMPANY_POLICY_TYPES_SUCCESS, data });
  } catch (error) {
    dispatch({ type: GET_COMPANY_POLICY_TYPES_FAILURE, error });
  }
};

const COMPANY_GET_USERS = 'COMPANY_GET_USERS';
const COMPANY_GET_USERS_SUCCESS = 'COMPANY_GET_USERS_SUCCESS';
const COMPANY_GET_USERS_FAILURE = 'COMPANY_GET_USERS_FAILURE';

export const getCompanyUsers = (companyId = null) => async (dispatch, getState) => {
  dispatch({ type: COMPANY_GET_USERS });

  const currentCompanyId = companyId ?? selectCompanyId(getState());

  try {
    const data = await portalApi.getCompanyUsers(currentCompanyId);

    const users = data.filter(user => user.is_active);

    dispatch({ type: COMPANY_GET_USERS_SUCCESS, users });
  } catch (error) {
    dispatch({ type: COMPANY_GET_USERS_FAILURE, error });
  }
};

const COMPANY_UPDATE_COMPANY_SETTING = 'COMPANY_UPDATE_COMPANY_SETTING';
const COMPANY_UPDATE_COMPANY_SETTING_SUCCESS = 'COMPANY_UPDATE_COMPANY_SETTING_SUCCESS';
const COMPANY_UPDATE_COMPANY_SETTING_FAILURE = 'COMPANY_UPDATE_COMPANY_SETTING_FAILURE';

export const updateCompanySetting = (companyId, settingTypeId, isEnabled, value) => async (dispatch, getState) => {
  const original = selectCompanySetting(settingTypeId)(getState());
  dispatch({ type: COMPANY_UPDATE_COMPANY_SETTING, companyId, settingTypeId, isEnabled, value });

  try {
    const response = await portalApi.updateCompanySetting(companyId, settingTypeId, isEnabled, value);
    dispatch({ type: COMPANY_UPDATE_COMPANY_SETTING_SUCCESS, response });
  } catch (error) {
    dispatch({ type: COMPANY_UPDATE_COMPANY_SETTING_FAILURE, error: error.message, original });
  }
};

const COMPANY_GET_CUSTOM_DOMAIN_DETAILS = 'COMPANY_GET_CUSTOM_DOMAIN_DETAILS';
const COMPANY_GET_CUSTOM_DOMAIN_DETAILS_SUCCESS = 'COMPANY_GET_CUSTOM_DOMAIN_DETAILS_SUCCESS';
const COMPANY_GET_CUSTOM_DOMAIN_DETAILS_FAILURE = 'COMPANY_GET_CUSTOM_DOMAIN_DETAILS_FAILURE';

export const getCompanyCustomDomainDetails = companyId => async dispatch => {
  dispatch({ type: COMPANY_GET_CUSTOM_DOMAIN_DETAILS, companyId });

  try {
    const response = await portalApi.getCompanyCustomDomainDetails(companyId);

    dispatch({ type: COMPANY_GET_CUSTOM_DOMAIN_DETAILS_SUCCESS, companyId, response });
  } catch (error) {
    dispatch({ type: COMPANY_GET_CUSTOM_DOMAIN_DETAILS_FAILURE, error });
  }
};

const COMPANY_CREATE_CUSTOM_DOMAIN = 'COMPANY_CREATE_CUSTOM_DOMAIN';
const COMPANY_CREATE_CUSTOM_DOMAIN_SUCCESS = 'COMPANY_CREATE_CUSTOM_DOMAIN_SUCCESS';
const COMPANY_CREATE_CUSTOM_DOMAIN_FAILURE = 'COMPANY_CREATE_CUSTOM_DOMAIN_FAILURE';

export const createCompanyCustomDomain = (companyId, domain) => async dispatch => {
  dispatch({ type: COMPANY_CREATE_CUSTOM_DOMAIN, companyId, domain });

  dispatch(createToast({ title: 'Creating Domain...', duration: 20000 }));

  try {
    const response = await portalApi.createCompanyCustomDomain(companyId, domain);

    await dispatch(getCompany(companyId));

    dispatch({ type: COMPANY_CREATE_CUSTOM_DOMAIN_SUCCESS, companyId, domain, response });
    dispatch(createSuccessToast({ title: 'Domain created successfully!' }));
    dispatch(hideModal());
  } catch (error) {
    dispatch({ type: COMPANY_CREATE_CUSTOM_DOMAIN_FAILURE, error });
    dispatch(createErrorToast({ title: 'Something went wrong while trying to delete your domain.', error }));
  }
};

const COMPANY_VERIFY_CUSTOM_DOMAIN = 'COMPANY_VERIFY_CUSTOM_DOMAIN';
const COMPANY_VERIFY_CUSTOM_DOMAIN_SUCCESS = 'COMPANY_VERIFY_CUSTOM_DOMAIN_SUCCESS';
const COMPANY_VERIFY_CUSTOM_DOMAIN_FAILURE = 'COMPANY_VERIFY_CUSTOM_DOMAIN_FAILURE';

export const verifyCompanyCustomDomain = companyId => async dispatch => {
  dispatch({ type: COMPANY_VERIFY_CUSTOM_DOMAIN, companyId });

  dispatch(createToast({ title: 'Verifying Domain...', duration: 20000 }));

  try {
    const response = await portalApi.verifyCompanyCustomDomain(companyId);

    const domainState = response?.state;

    await dispatch(getCompany(companyId));
    dispatch({ type: COMPANY_VERIFY_CUSTOM_DOMAIN_SUCCESS, companyId, response, domainState });

    if (domainState === 'active') {
      dispatch(createSuccessToast({ title: 'Domain verified!', description: 'Setting has been enabled' }));
    } else {
      dispatch(createToast({ title: 'Domain was not verified', description: 'Setting is disabled', status: 'warning' }));
    }
  } catch (error) {
    dispatch({ type: COMPANY_VERIFY_CUSTOM_DOMAIN_FAILURE, error });
    dispatch(createErrorToast({ title: 'Something went wrong while trying to verify your domain.', error }));
  }
};

const COMPANY_DELETE_CUSTOM_DOMAIN = 'COMPANY_DELETE_CUSTOM_DOMAIN';
const COMPANY_DELETE_CUSTOM_DOMAIN_SUCCESS = 'COMPANY_DELETE_CUSTOM_DOMAIN_SUCCESS';
const COMPANY_DELETE_CUSTOM_DOMAIN_FAILURE = 'COMPANY_DELETE_CUSTOM_DOMAIN_FAILURE';

export const deleteCompanyCustomDomain = companyId => async dispatch => {
  dispatch({ type: COMPANY_DELETE_CUSTOM_DOMAIN, companyId });

  dispatch(createToast({ title: 'Deleting Domain...', duration: 20000 }));

  try {
    const response = await portalApi.deleteCompanyCustomDomain(companyId);

    await dispatch(getCompany(companyId));

    dispatch({ type: COMPANY_DELETE_CUSTOM_DOMAIN_SUCCESS, companyId, response });
    dispatch(createSuccessToast({ title: 'Domain deleted!' }));
  } catch (error) {
    dispatch({ type: COMPANY_DELETE_CUSTOM_DOMAIN_FAILURE, error });
    dispatch(createErrorToast({ title: 'Something went wrong while trying to delete your domain.', error }));
  }
};

const DEFAULT_STATE = {
  companyId: null,
  companyIsLoaded: false,
  stats: {
    isLoading: false,
    data: []
  },
  features: [],
  codes: [],
  projects: null,
  policyTypes: null,
  departments: [],
  departmentsPageInfo: null,
  domain: null,
  domainDetailsLoading: false,
  domainCreatingLoading: false,
  domainVerifyLoading: false,
  domainDeleteLoading: false
};

const companyReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case GET_COMPANY:
      return {
        ...state,
        companyId: parseInt(action.companyId, 10)
      };
    case GET_COMPANY_STATS:
      return {
        ...state,
        stats: { ...state.stats, isLoading: true }
      };

    case GET_COMPANY_SUCCESS:
      return {
        ...state,
        companyIsLoaded: true,
        ...action.company
      };

    case GET_COMPANY_FEATURES_SUCCESS:
      return {
        ...state,
        features: action.features
      };

    case GET_COMPANY_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        integrations: action.integrations
      };

    case GET_COMPANY_DEPARTMENTS_SUCCESS: {
      const receivedData = action.pageInfo.currentPage !== 1
        ? [...state.departments, ...action.departments]
        : action.departments;

      return {
        ...state,
        departments: receivedData,
        departmentsPageInfo: action.pageInfo,
        adminDepartment: action.adminDepartmentId
      };
    }

    case GET_COMPANY_CODES_SUCCESS:
      return {
        ...state,
        codes: action.codes
      };

    case GET_COMPANY_STATS_SUCCESS:
      return {
        ...state,
        stats: { ...state.stats, isLoading: false, data: action.stats }
      };

    case GET_COMPANY_PROJECTS_SUCCESS:
      return {
        ...state,
        projects: action.data
      };

    case GET_COMPANY_POLICY_TYPES_SUCCESS:
      return {
        ...state,
        policyTypes: action.data
      };

    case COMPANY_GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.users
      };

    case GET_COMPANY_FAILURE:
      return { ...state, error: action.error, companyIsLoaded: false };

    case GET_COMPANY_STATS_FAILURE:
      return { ...state, stats: { isLoading: false }, error: action.error };

    case COMPANY_UPDATE_COMPANY_SETTING:
      return {
        ...state,
        settings: replaceArrayItemAt(state.settings, 'id', action.settingTypeId, {
          ...state.settings.find(s => s.id === action.settingTypeId),
          isEnabled: action.isEnabled,
          value: action.value
        })
      };

    case COMPANY_UPDATE_COMPANY_SETTING_FAILURE:
      return {
        ...state,
        settings: replaceArrayItemAt(state.settings, 'id', action.original)
      };

    case COMPANY_GET_CUSTOM_DOMAIN_DETAILS:
      return {
        ...state,
        domainDetailsLoading: true
      };

    case COMPANY_GET_CUSTOM_DOMAIN_DETAILS_SUCCESS:
      return {
        ...state,
        domain: action.response,
        domainDetailsLoading: false
      };

    case COMPANY_GET_CUSTOM_DOMAIN_DETAILS_FAILURE:
      return {
        ...state,
        domainDetailsLoading: false
      };

    case COMPANY_CREATE_CUSTOM_DOMAIN:
      return {
        ...state,
        domainCreatingLoading: true
      };

    case COMPANY_CREATE_CUSTOM_DOMAIN_SUCCESS:
      return {
        ...state,
        domain: action.response,
        domainCreatingLoading: false
      };

    case COMPANY_CREATE_CUSTOM_DOMAIN_FAILURE:
      return {
        ...state,
        domainCreatingLoading: false
      };

    case COMPANY_VERIFY_CUSTOM_DOMAIN:
      return {
        ...state,
        domainVerifyLoading: true
      };

    case COMPANY_VERIFY_CUSTOM_DOMAIN_SUCCESS:
      return {
        ...state,
        domain: action.response,
        domainVerifyLoading: false
      };

    case COMPANY_VERIFY_CUSTOM_DOMAIN_FAILURE:
      return {
        ...state,
        domainVerifyLoading: false
      };

    case COMPANY_DELETE_CUSTOM_DOMAIN:
      return {
        ...state,
        domainDeleteLoading: true
      };

    case COMPANY_DELETE_CUSTOM_DOMAIN_SUCCESS:
      return {
        ...state,
        domain: null,
        domainDeleteLoading: false
      };

    case COMPANY_DELETE_CUSTOM_DOMAIN_FAILURE:
      return {
        ...state,
        domainDeleteLoading: false
      };

    default:
      return state;
  }
};

// stable fallback so the selector doesn't return a new array reference on every call
const noFeatures = [];

export const selectCompany = state => state.company;
export const selectCompanyFeatures = state => state.company?.features || noFeatures;
export const selectCompanyIntegrations = state => state.company?.integrations || [];
export const selectCompanyStats = state => state.company.stats.data;
export const selectAreCompanyStatsLoading = state => state.company.stats.isLoading;
export const selectCompanyId = state => state.company.companyId;
export const selectCompanyCodes = state => state.company.codes;
export const selectCompanyPolicyTypes = state => state.company.policyTypes;
export const selectCompanyUsers = state => state.company.users;
export const selectCompanySettings = state => state.company.settings;
export const selectCompanySetting = setting => state => state.company.settings.find(s => s.name === setting);
export const selectCompanySettingValue = setting => state => state.company.settings.find(s => s.name === setting)?.value;
export const selectCompanyDepartments = state => state.company.departments;
export const selectActiveDepartments = state => (state.company.departments ? state.company.departments.filter(d => !d.archivedAt) : null);
export const selectCompanyDepartmentsPageInfo = state => state.company.departmentsPageInfo;
export const selectCompanyDocumentTypes = state => state.company.insuranceDocumentTypes;
export const selectCompanyCustomDomain = state => state.company.domain;
export const selectCompanyCustomDomainDetailsLoading = state => state.company.domainDetailsLoading;
export const selectCompanyCustomDomainCreatingLoading = state => state.company.domainCreatingLoading;
export const selectCompanyCustomDomainVerifyLoading = state => state.company.domainVerifyLoading;
export const selectCompanyCustomDomainDeleteLoading = state => state.company.domainDeleteLoading;

export default companyReducer;
